import "./cardConfrontation.sass";

function TeamSlot({ team, reverse }) {
  return (
    <div className="confrontation-team">
      {/* Logo primero si NO reverse, al final si reverse */}
      {!reverse && (
        <div className="confrontation-team__logo-wrapper">
          <img src={team.img} alt={team.contestantShortName} loading="lazy" />
          <span className="confrontation-team__rank">{team.rank}</span>
        </div>
      )}
      
      <p>{team.contestantShortName}</p>
      
      {reverse && (
        <div className="confrontation-team__logo-wrapper">
          <img src={team.img} alt={team.contestantShortName} loading="lazy" />
          <span className="confrontation-team__rank">{team.rank}</span>
        </div>
      )}
    </div>
  );
}

export default function CardConfrontation({ item }) {
  const { home, away } = item;

  return (
    <div className="confrontation__card-teams">
      <TeamSlot team={home} />
      <div className="vs-separator">VS</div>
      <TeamSlot team={away} reverse />
    </div>
  );
}